import { render, staticRenderFns } from "./agent.vue?vue&type=template&id=54861ae3&scoped=true"
import script from "./agent.vue?vue&type=script&lang=js"
export * from "./agent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54861ae3",
  null
  
)

export default component.exports